import { FC } from 'react';
import { styled, Switch, SwitchProps } from '@mui/material';

const StyledSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 48,
  height: 28,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 3.5,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(21px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#26A46F',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 20,
    backgroundColor: '#B4B4C5',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

interface ToggleProps {
  checked: boolean;
  onChange: () => void;
  onBlur?: () => void;
}

export const Toggle: FC<ToggleProps> = ({ checked, onChange, onBlur }) => {
  return <StyledSwitch checked={checked} onChange={onChange} onBlur={onBlur} />;
};
